import {CanActivateFn, Router} from '@angular/router';
import {AuthStateService} from "../services/auth/auth-state.service";
import { inject } from '@angular/core';
import {User} from "../../models/User";

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(AuthStateService);
  const router = inject(Router);
  // const expectedRoles = route.data['roles'];
  // const user: User | null = userService.currentUserValue();

  if (!userService.isLoggedIn()) {
    router.navigate(['login']); // Redirige a la página de login si no está autenticado
    return false;
  }

  const currentUser = userService.currentUserValue;
  
  // Verificar que el usuario tenga roles
  if (!currentUser || !currentUser.roles || currentUser.roles.length === 0) {
    // Usuario sin roles, cerrar sesión y redirigir al login
    userService.setUser(null);
    router.navigate(['login']);
    return false;
  }

  /*if (userService.isLoggedIn() && !userService.isNotProfessional()) {
    router.navigate(['']); // Redirige a la página de login si no está autenticado
    return false;
  }*/

  /*if (expectedRoles && user && !hasRole(user, expectedRoles)) {
    router.navigate(['/']); // Redirige a una página de acceso denegado si no tiene el rol adecuado
    return false;
  }*/

  return true;
};

/*const hasRole = (user: User, roles: string[]): boolean => {
  return roles.some(role => user.role === role);
};*/
